import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'
import { stripLegacyPackageRefPrefix } from '../../../_common/packageRef'

// Defines what data should be loaded for this component, the data in here is
// fetched in parallel with navigating to the route and is then passed to the
// component as a prop.
export default async function loader({ params }) {
  const packageId = stripLegacyPackageRefPrefix(params.packageId)

  const rulePackage = mercuryApi
    .get(`/pay-rules/packages/${packageId}`)
    .then((result) => {
      return result
    })

  const previousActivation = mercuryApi
    .get(`/pay-rules/packages/activate/${packageId}`)
    .then((result) => {
      return result
    })

  return defer({
    data: Promise.all([rulePackage, previousActivation]),
  })
}
